<app-help-page mainVideo="calculated-metrics"
               [tutorials]="['calculated-metrics', 'calculated-metrics-definition']"
               [videos]="['calculated-metrics']"></app-help-page>
